const PrepareBHKString = (bhk) =>
  bhk.enableLabel
    ? bhk.label
    : bhk.min < bhk.max
    ? bhk.min + " - " + bhk.max + " BHK"
    : bhk.min + " BHK";
export default PrepareBHKString;
